module.exports = __webpack_public_path__ + "static/replace-3d91cb21eec69166a3fea7e8f08546c1.png";